"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ACCOUNT_TYPES = void 0;
exports.ACCOUNT_TYPES = {
    CASH: 'CASH',
    BANK: 'BANK',
    CREDIT: 'CREDIT',
    GOAL: 'GOAL',
    INVESTMENT: 'INVESTMENT',
    LOAN: 'LOAN',
};
